module.exports = __webpack_public_path__ + "static/media/success.ed1da4ac.svg";